// SIAP Import Preview
document.addEventListener('DOMContentLoaded', function() {
  const fileInput = document.getElementById('siap_import_file');

  if (!fileInput) return;

  fileInput.addEventListener('change', function(e) {
    const file = e.target.files[0];

    if (!file) return;

    // Show loading overlay
    showLoadingOverlay('Analyzing file...');

    // Create form data
    const formData = new FormData();
    formData.append('file', file);

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    // Send preview request
    fetch('/admin/siap_integrations/import_preview', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Hide loading overlay
      hideLoadingOverlay();

      if (data.error) {
        alert(data.error);
        fileInput.value = '';
        return;
      }

      // Populate modal with data
      populatePreviewModal(data);

      // Show modal
      $('#siapImportPreviewModal').modal('show');

      // Reset file input
      fileInput.value = '';
    })
    .catch(error => {
      // Hide loading overlay
      hideLoadingOverlay();

      console.error('Error:', error);
      alert('An error occurred while processing the file.');
      fileInput.value = '';
    });
  });

  // Add loading state to confirm button
  const confirmForm = document.getElementById('import-confirm-form');
  if (confirmForm) {
    confirmForm.addEventListener('submit', function() {
      const btn = document.getElementById('import-confirm-btn');
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = `
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Importing...
        `;
      }
      showLoadingOverlay('Importing data...');
    });
  }
});

// Loading overlay functions
function showLoadingOverlay(message) {
  // Remove existing overlay if any
  hideLoadingOverlay();

  const overlay = document.createElement('div');
  overlay.id = 'siap-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(27, 33, 43, 0.95);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  overlay.innerHTML = `
    <div class="text-center">
      <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
        <span class="sr-only">Loading...</span>
      </div>
      <h5 style="color: #fff;">${message}</h5>
      <p style="color: #bcbdbf;">Please wait...</p>
    </div>
  `;

  document.body.appendChild(overlay);
}

function hideLoadingOverlay() {
  const overlay = document.getElementById('siap-loading-overlay');
  if (overlay) {
    overlay.remove();
  }
}

function populatePreviewModal(data) {
  // Update tab badges
  document.getElementById('valid-badge').textContent = data.summary.valid_count;
  document.getElementById('ignored-badge').textContent = data.summary.ignored_count;
  document.getElementById('errors-badge').textContent = data.summary.errors_count;

  // Store token for confirmation
  document.getElementById('import-token').value = data.token;

  // Populate Valid tab
  populateValidRecords(data.valid);

  // Populate Ignored tab
  populateIgnoredRecords(data.ignored);

  // Populate Errors tab
  populateErrors(data.errors);
}

function populateValidRecords(valid) {
  // Users
  const usersCount = valid.users.length;
  document.getElementById('valid-users-count').textContent = usersCount;

  const usersList = document.getElementById('valid-users-list');
  usersList.innerHTML = '';

  if (usersCount === 0) {
    usersList.innerHTML = '<p style="color: #bcbdbf;">No users to update</p>';
  } else {
    valid.users.forEach(user => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
          <div style="color: #fff;">
            <strong>ID: ${user.id}</strong> - ${user.identifier}
            <br>
            <small style="color: #bcbdbf;">${user.email}</small>
          </div>
          <div class="text-right">
            <span class="badge badge-secondary">${user.old_code || '(empty)'}</span>
            <i class="fas fa-arrow-right mx-2" style="color: #fff;"></i>
            <span class="badge badge-success">${user.new_code || '(empty)'}</span>
          </div>
        </div>
      `;
      usersList.appendChild(item);
    });
  }

  // Clubs
  const clubsCount = valid.clubs.length;
  document.getElementById('valid-clubs-count').textContent = clubsCount;

  const clubsList = document.getElementById('valid-clubs-list');
  clubsList.innerHTML = '';

  if (clubsCount === 0) {
    clubsList.innerHTML = '<p style="color: #bcbdbf;">No clubs to update</p>';
  } else {
    valid.clubs.forEach(club => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
          <div style="color: #fff;">
            <strong>ID: ${club.id}</strong> - ${club.identifier}
          </div>
          <div class="text-right">
            <span class="badge badge-secondary">${club.old_code || '(empty)'}</span>
            <i class="fas fa-arrow-right mx-2" style="color: #fff;"></i>
            <span class="badge badge-success">${club.new_code || '(empty)'}</span>
          </div>
        </div>
      `;
      clubsList.appendChild(item);
    });
  }

  // Fixtures
  const fixturesCount = valid.fixtures.length;
  document.getElementById('valid-fixtures-count').textContent = fixturesCount;

  const fixturesList = document.getElementById('valid-fixtures-list');
  fixturesList.innerHTML = '';

  if (fixturesCount === 0) {
    fixturesList.innerHTML = '<p style="color: #bcbdbf;">No fixtures to update</p>';
  } else {
    valid.fixtures.forEach(fixture => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
          <div style="color: #fff;">
            <strong>ID: ${fixture.id}</strong> - ${fixture.identifier}
          </div>
          <div class="text-right">
            <span class="badge badge-secondary">${fixture.old_code || '(empty)'}</span>
            <i class="fas fa-arrow-right mx-2" style="color: #fff;"></i>
            <span class="badge badge-success">${fixture.new_code || '(empty)'}</span>
          </div>
        </div>
      `;
      fixturesList.appendChild(item);
    });
  }

  // Competitions
  const competitionsCount = valid.competitions.length;
  document.getElementById('valid-competitions-count').textContent = competitionsCount;

  const competitionsList = document.getElementById('valid-competitions-list');
  competitionsList.innerHTML = '';

  if (competitionsCount === 0) {
    competitionsList.innerHTML = '<p style="color: #bcbdbf;">No competitions to update</p>';
  } else {
    valid.competitions.forEach(competition => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
          <div style="color: #fff;">
            <strong>ID: ${competition.id}</strong> - ${competition.identifier}
          </div>
          <div class="text-right">
            <span class="badge badge-secondary">${competition.old_code || '(empty)'}</span>
            <i class="fas fa-arrow-right mx-2" style="color: #fff;"></i>
            <span class="badge badge-success">${competition.new_code || '(empty)'}</span>
          </div>
        </div>
      `;
      competitionsList.appendChild(item);
    });
  }

  // Rounds
  const roundsCount = valid.rounds.length;
  document.getElementById('valid-rounds-count').textContent = roundsCount;

  const roundsList = document.getElementById('valid-rounds-list');
  roundsList.innerHTML = '';

  if (roundsCount === 0) {
    roundsList.innerHTML = '<p style="color: #bcbdbf;">No rounds to update</p>';
  } else {
    valid.rounds.forEach(round => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
          <div style="color: #fff;">
            <strong>ID: ${round.id}</strong> - ${round.identifier}
          </div>
          <div class="text-right">
            <span class="badge badge-secondary">${round.old_code || '(empty)'}</span>
            <i class="fas fa-arrow-right mx-2" style="color: #fff;"></i>
            <span class="badge badge-success">${round.new_code || '(empty)'}</span>
          </div>
        </div>
      `;
      roundsList.appendChild(item);
    });
  }
}

function populateIgnoredRecords(ignored) {
  // Users
  const usersCount = ignored.users.length;
  document.getElementById('ignored-users-count').textContent = usersCount;

  const usersList = document.getElementById('ignored-users-list');
  usersList.innerHTML = '';

  if (usersCount === 0) {
    usersList.innerHTML = '<p style="color: #bcbdbf;">No ignored users</p>';
  } else {
    ignored.users.forEach(user => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 193, 7, 0.1)';
      item.style.borderLeft = '3px solid #ffc107';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div style="color: #fff;">
          <strong>Row ${user.row}</strong> - ID: ${user.id || 'N/A'}
          <br>
          <small style="color: #bcbdbf;">${user.reason}</small>
        </div>
      `;
      usersList.appendChild(item);
    });
  }

  // Clubs
  const clubsCount = ignored.clubs.length;
  document.getElementById('ignored-clubs-count').textContent = clubsCount;

  const clubsList = document.getElementById('ignored-clubs-list');
  clubsList.innerHTML = '';

  if (clubsCount === 0) {
    clubsList.innerHTML = '<p style="color: #bcbdbf;">No ignored clubs</p>';
  } else {
    ignored.clubs.forEach(club => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 193, 7, 0.1)';
      item.style.borderLeft = '3px solid #ffc107';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div style="color: #fff;">
          <strong>Row ${club.row}</strong> - ID: ${club.id || 'N/A'}
          <br>
          <small style="color: #bcbdbf;">${club.reason}</small>
        </div>
      `;
      clubsList.appendChild(item);
    });
  }

  // Fixtures
  const fixturesCount = ignored.fixtures.length;
  document.getElementById('ignored-fixtures-count').textContent = fixturesCount;

  const fixturesList = document.getElementById('ignored-fixtures-list');
  fixturesList.innerHTML = '';

  if (fixturesCount === 0) {
    fixturesList.innerHTML = '<p style="color: #bcbdbf;">No ignored fixtures</p>';
  } else {
    ignored.fixtures.forEach(fixture => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 193, 7, 0.1)';
      item.style.borderLeft = '3px solid #ffc107';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div style="color: #fff;">
          <strong>Row ${fixture.row}</strong> - ID: ${fixture.id || 'N/A'}
          <br>
          <small style="color: #bcbdbf;">${fixture.reason}</small>
        </div>
      `;
      fixturesList.appendChild(item);
    });
  }

  // Competitions
  const competitionsCount = ignored.competitions.length;
  document.getElementById('ignored-competitions-count').textContent = competitionsCount;

  const competitionsList = document.getElementById('ignored-competitions-list');
  competitionsList.innerHTML = '';

  if (competitionsCount === 0) {
    competitionsList.innerHTML = '<p style="color: #bcbdbf;">No ignored competitions</p>';
  } else {
    ignored.competitions.forEach(competition => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 193, 7, 0.1)';
      item.style.borderLeft = '3px solid #ffc107';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div style="color: #fff;">
          <strong>Row ${competition.row}</strong> - ID: ${competition.id || 'N/A'}
          <br>
          <small style="color: #bcbdbf;">${competition.reason}</small>
        </div>
      `;
      competitionsList.appendChild(item);
    });
  }

  // Rounds
  const roundsCount = ignored.rounds.length;
  document.getElementById('ignored-rounds-count').textContent = roundsCount;

  const roundsList = document.getElementById('ignored-rounds-list');
  roundsList.innerHTML = '';

  if (roundsCount === 0) {
    roundsList.innerHTML = '<p style="color: #bcbdbf;">No ignored rounds</p>';
  } else {
    ignored.rounds.forEach(round => {
      const item = document.createElement('div');
      item.className = 'mb-2 p-2';
      item.style.backgroundColor = 'rgba(255, 193, 7, 0.1)';
      item.style.borderLeft = '3px solid #ffc107';
      item.style.borderRadius = '4px';
      item.innerHTML = `
        <div style="color: #fff;">
          <strong>Row ${round.row}</strong> - ID: ${round.id || 'N/A'}
          <br>
          <small style="color: #bcbdbf;">${round.reason}</small>
        </div>
      `;
      roundsList.appendChild(item);
    });
  }
}

function populateErrors(errors) {
  const errorsList = document.getElementById('errors-list');
  errorsList.innerHTML = '';

  if (errors.length === 0) {
    errorsList.innerHTML = '<p style="color: #28a745;">No errors detected!</p>';
  } else {
    errors.forEach((error, index) => {
      const item = document.createElement('div');
      item.className = 'mb-3 p-3';
      item.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
      item.style.borderLeft = '3px solid #dc3545';
      item.style.borderRadius = '4px';
      item.id = `error-item-${index}`;

      let conflictHtml = '';
      if (error.existing_record && error.importing_record) {
        const entityType = error.entity.toLowerCase();
        conflictHtml = `
          <div style="margin-top: 10px; padding: 10px; background: rgba(0,0,0,0.2); border-radius: 4px;">
            <div style="color: #ffc107; margin-bottom: 8px;">
              <i class="fas fa-exclamation-triangle"></i> Code conflict detected
            </div>
            <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
              <div style="flex: 1; min-width: 200px;">
                <small style="color: #bcbdbf;">Already exists in:</small><br>
                <strong style="color: #fff;">ID: ${error.existing_record.id}</strong> - ${error.existing_record.identifier}
                <a href="${error.existing_record.url}" target="_blank" style="color: #17a2b8; margin-left: 5px;" title="View record">
                  <i class="fas fa-external-link-alt"></i>
                </a>
              </div>
              <div style="color: #fff;"><i class="fas fa-arrow-right"></i></div>
              <div style="flex: 1; min-width: 200px;">
                <small style="color: #bcbdbf;">Trying to assign to:</small><br>
                <strong style="color: #fff;">ID: ${error.importing_record.id}</strong> - ${error.importing_record.identifier}
                <a href="${error.importing_record.url}" target="_blank" style="color: #17a2b8; margin-left: 5px;" title="View record">
                  <i class="fas fa-external-link-alt"></i>
                </a>
              </div>
            </div>
            <div style="margin-top: 12px; padding-top: 10px; border-top: 1px solid rgba(255,255,255,0.1);">
              <small style="color: #bcbdbf;">
                <i class="fas fa-info-circle"></i>
                Please review if this is a registration error. To assign code <strong>'${error.code}'</strong> to the new record,
                remove it from the existing one first.
              </small>
              <div style="margin-top: 8px;">
                <button type="button" class="btn btn-sm btn-outline-warning clear-code-btn"
                        data-entity-type="${entityType}"
                        data-entity-id="${error.existing_record.id}"
                        data-code="${error.code}"
                        data-error-index="${index}">
                  <i class="fas fa-eraser"></i> Remove code from ID ${error.existing_record.id}
                </button>
              </div>
            </div>
          </div>
        `;
      } else if (error.existing_record) {
        conflictHtml = `
          <br>
          <small style="color: #bcbdbf;">
            Existing record: <strong>ID: ${error.existing_record.id}</strong> - ${error.existing_record.identifier}
            <a href="${error.existing_record.url}" target="_blank" style="color: #17a2b8; margin-left: 8px;">
              <i class="fas fa-external-link-alt"></i> View
            </a>
          </small>
        `;
      }

      item.innerHTML = `
        <div style="color: #fff;">
          <strong>Row ${error.row}</strong> - ${error.entity}
          <br>
          <small style="color: #bcbdbf;">${error.message}</small>
          ${conflictHtml}
        </div>
      `;
      errorsList.appendChild(item);
    });

    // Add event listeners for clear code buttons
    document.querySelectorAll('.clear-code-btn').forEach(btn => {
      btn.addEventListener('click', handleClearCode);
    });
  }
}

function handleClearCode(e) {
  const btn = e.currentTarget;
  const entityType = btn.dataset.entityType;
  const entityId = btn.dataset.entityId;
  const code = btn.dataset.code;
  const errorIndex = btn.dataset.errorIndex;

  if (!confirm(`Are you sure you want to remove code '${code}' from ${entityType.slice(0, -1)} ID ${entityId}?`)) {
    return;
  }

  btn.disabled = true;
  btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Removing...';

  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  fetch('/admin/siap_integrations/clear_code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({
      entity_type: entityType,
      entity_id: entityId
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      const errorItem = document.getElementById(`error-item-${errorIndex}`);
      if (errorItem) {
        errorItem.style.backgroundColor = 'rgba(40, 167, 69, 0.1)';
        errorItem.style.borderLeftColor = '#28a745';
        errorItem.innerHTML = `
          <div style="color: #28a745;">
            <i class="fas fa-check-circle"></i> ${data.message}
            <br>
            <small style="color: #bcbdbf;">Please re-upload the file to continue with the import.</small>
          </div>
        `;
      }

      // Update error badge count
      const errorBadge = document.getElementById('errors-badge');
      if (errorBadge) {
        const currentCount = parseInt(errorBadge.textContent) || 0;
        if (currentCount > 0) {
          errorBadge.textContent = currentCount - 1;
        }
      }
    } else {
      alert('Error: ' + (data.error || 'Unknown error'));
      btn.disabled = false;
      btn.innerHTML = `<i class="fas fa-eraser"></i> Remove code from ID ${entityId}`;
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('An error occurred while removing the code.');
    btn.disabled = false;
    btn.innerHTML = `<i class="fas fa-eraser"></i> Remove code from ID ${entityId}`;
  });
}
